// src/components/CourseContent.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

// All your content component imports
import VideoPlayer from './VideoPlayer';
import PdfViewer from './PdfViewer';
import QuizViewer from './QuizViewer';
import QuizViewerWithAttempts from './quiz-attempts/QuizViewerWithAttempts';
import NavigationButton from "./NavgiationButtons";
import CodeEditor from './CodeEditor/CodeEditor';
import CodeEditorDB from './CodeEditor/CodeEditorDB';
import ImageRenderer from './ImageRenderer';
import AudioPlayer from './AudioPlayer';
// import ContentChatbot from './ContentChatbot'; // Import the new ChatComponent
import SakhaChatbot from 'components/chatbot/SakhaChatbot';

const CourseContent = ({
  activeContent,
  setActiveContent,
  courseDetails,
  videoProgress,
  quizStatus,
  setQuizStatus,
  quizStartedAt,
  setQuizStartedAt,
  videoDuration,
  setVideoDuration,
}) => {
  const [type, setType] = useState(activeContent?.contentType);
  const [cookies] = useCookies(['userId', 'roleId']);
  const { courseId, sectionId } = useParams();
  const navigate = useNavigate();

  const theme = useTheme();

  useEffect(() => {
    setType(activeContent?.contentType);
  }, [activeContent]);

  if (!activeContent) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6">Please select content from the sidebar.</Typography>
      </Box>
    );
  }

  return (
    <Box
      className="course-content-inner-container"
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, // Responsive: column on mobile, row on desktop
        alignItems: 'flex-start',
        padding: theme.spacing(2),
        gap: theme.spacing(2), // Add gap between columns
      }}
    >
      {/* Left Column: Main Content */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {(() => {
          if (activeContent?.contentType === 'video') {
            return (
              <>
                <VideoPlayer
                  activeContent={activeContent}
                  fileName={activeContent.contentFileName}
                  videoProgress={videoProgress}
                  videoDuration={videoDuration}
                  setVideoDuration={setVideoDuration}
                />
                {/* <NavigationButton
                  courseDetails={courseDetails}
                  activeContent={activeContent}
                  setActiveContent={setActiveContent}
                /> */}
              </>
            );
          } else if (activeContent?.contentType === 'supplementaryMaterial') {
            return (
              <>
                <PdfViewer
                  activeContent={activeContent}
                  fileName={activeContent.contentFileName}
                  key={activeContent.contentId}
                />
                {/* <NavigationButton
                  courseDetails={courseDetails}
                  activeContent={activeContent}
                  setActiveContent={setActiveContent}
                /> */}
              </>
            );
          } else if (activeContent?.contentType === 'quiz') {
            return (
              <QuizViewerWithAttempts
                key={activeContent.contentId}
                courseDetails={courseDetails}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
                quizStatus={quizStatus}
                setQuizStatus={setQuizStatus}
                quizStartedAt={quizStartedAt}
                setQuizStartedAt={setQuizStartedAt}
              />
            );
          } else if (activeContent?.contentType === 'quizSubjective') {
            return (
              <QuizViewer
                key={activeContent.contentId}
                courseDetails={courseDetails}
                activeContent={activeContent}
                setActiveContent={setActiveContent}
                quizStatus={quizStatus}
                setQuizStatus={setQuizStatus}
                quizStartedAt={quizStartedAt}
                setQuizStartedAt={setQuizStartedAt}
              />
            );
          }


          else if (activeContent?.contentType === 'codeSandbox') {
            return (
              <>
                {['sql', 'sqlite3', 'MySQL'].includes(activeContent?.language) ? (
                  <CodeEditorDB
                    key={activeContent.contentId}
                    problemStatement={activeContent.problemStatement}
                    activeContent={activeContent}
                  />
                ) : (
                  <CodeEditor
                    key={activeContent.contentId}
                    problemStatement={activeContent.problemStatement}
                    activeContent={activeContent}
                  />
                )}
                {/* <NavigationButton
                  courseDetails={courseDetails}
                  activeContent={activeContent}
                  setActiveContent={setActiveContent}
                /> */}
              </>
            );
          } else if (activeContent?.contentType === 'image') {
            return (
              <>
                <ImageRenderer
                  activeContent={activeContent}
                  fileName={activeContent.contentFileName}
                />
                {/* <NavigationButton
                  courseDetails={courseDetails}
                  activeContent={activeContent}
                  setActiveContent={setActiveContent}
                /> */}
              </>
            );
          } else if (activeContent?.contentType === 'audio') {
            return (
              <>
                <AudioPlayer
                  activeContent={activeContent}
                  fileName={activeContent.contentFileName}
                />
                {/* <NavigationButton
                  courseDetails={courseDetails}
                  activeContent={activeContent}
                  setActiveContent={setActiveContent}
                /> */}
              </>
            );
          }
          return null;
        })()}
      </Box>

      {/* Sakha Chatbot - floating widget, shown for video and pdf content */}
      {(activeContent?.contentType === 'video' || activeContent?.contentType === 'supplementaryMaterial') && (
        <SakhaChatbot />
      )}
    </Box>
  );
};

export default CourseContent;